import React from 'react';
import ProviderSessionTab from './ProviderSessionTab';
import { Patient } from '../../../services/firebase/FirebasePatientService';
import { Appointment } from '../../../services/firebase/FirebaseAppointmentService';

interface SessionsTabProps {
  preSelectedPatient?: Patient | null;
  preSelectedAppointment?: Appointment | null;
}

// Simple wrapper to use the new advanced SessionService-powered component
const SessionsTab: React.FC<SessionsTabProps> = ({ preSelectedPatient, preSelectedAppointment }) => {
  return <ProviderSessionTab preSelectedPatient={preSelectedPatient} preSelectedAppointment={preSelectedAppointment} />;
};

export default SessionsTab;
